import Vue from 'vue'
import Vuex from 'vuex'

import notifications_alert from  './modules/alert'
import auth from './modules/auth/auth'
import trucker from './modules/admin/trucker'
import admin_price from './modules/admin/prices'
import admin_add_on from './modules/admin/add_ons'

Vue.use(Vuex)

export default new Vuex.Store({
      modules:{
        notifications_alert,
        auth,
        trucker,
        admin_price,
        admin_add_on
      }
})